export let setting = null;

switch (process.env.NODE_ENV) {
    case 'dev1':
        setting = require('@/setting/dev1.json');
        break;
    case 'dev3':
        setting = require('@/setting/dev3.json');
        break;
    case 'production':
        setting = require('@/setting/production.json');
        break;
    default:
        setting = require('@/setting/development.json');
}
